export default __webpack_public_path__ + "static/media/252025.3ba049c4.svg";